import { Button, message } from "antd";
import { FormDialog, FormLayout, FormItem, Input } from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { message as messageService } from "@/services";
const schema = {
  type: "object",
  properties: {
    bounce_comment: {
      type: "string",
      title: "原因",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input.TextArea",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
  },
});

function MessageBackButton({
  type,
  size = "default",
  token,
  messageId,
  callback,
}) {
  return (
    <FormDialog.Portal>
      <Button
        type={type}
        size={size}
        onClick={() => {
          FormDialog({ title: "退件" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={4} wrapperCol={16}>
                <SchemaField schema={schema} />
              </FormLayout>
            );
          })
            .forConfirm((payload, next) => {
              messageService
                .backMessage(messageId, payload.values, token)
                .then((res) => {
                  message.success("退件成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      >
        退 件
      </Button>
    </FormDialog.Portal>
  );
}

export default MessageBackButton;
